<cdk-tree *ngIf="TREE_DATA.length" [dataSource]="treeDataSource" [treeControl]="treeControl">
  <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="tree-node" [hidden]="node.hidden"
    [ngClass]="{'mb-0':hideField}">
    <!-- <button mat-icon-button disabled></button> -->
    <mat-checkbox class="checklist-leaf-node" *ngIf="!isView"
      [checked]="treeSelection.isSelected(node) || isInArray(selectedItems, node)"
      (change)="treeSelection.toggle(node); selected(node);">{{node.name}}</mat-checkbox>
    <span *ngIf="isView">{{node.name}}</span>
    <div class="form-group">
      <input class="form-control" *ngIf="!hideField" [(ngModel)]="node.priority" placeholder="Priority"
        [disabled]="(!treeSelection.isSelected(node) && !isInArray(selectedItems, node)) || disabledField"
        appOnlynumber>
      <p class="has-error d-none"
        [ngClass]="{'d-block':(!node.priority && node.priority !== 0) && !hideField && (treeSelection.isSelected(node) || isInArray(selectedItems, node))}">
        {{ 'forms.required' | translate }}</p>
      <p class="has-error d-none"
        [ngClass]="{'d-block':(node.priority && node.priority !== 0) && uniqPriority(node) && !hideField}">
        Duplicated
      </p>
    </div>
  </cdk-nested-tree-node>
  <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: hasChild" class="tree-node d-block mb-0"
    [hidden]="node.hidden">
    <button mat-icon-button type="button" [attr.aria-label]="'toggle ' + node.name" cdkTreeNodeToggle>
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) && !isExpand ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <mat-checkbox *ngIf="!isView && selectionParent" [checked]="descendantsAllSelected(node)"
      [indeterminate]="descendantsPartiallySelected(node)" (change)="todoItemSelectionToggle(node); selected(node);">
      {{node.name}}</mat-checkbox>
    <span *ngIf="!selectionParent || isView">{{node.name}}</span>
    <div [class.tree-invisible]="(isExpand)? treeControl.isExpanded(node) : !treeControl.isExpanded(node)" class="child_node">
      <ng-container cdkTreeNodeOutlet></ng-container>
    </div>
  </cdk-nested-tree-node>
</cdk-tree>